import React, { useState, memo, useMemo } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'shards-react';
import { connect } from 'react-redux';
import { reorderThumbnails } from '../../../utils/redux/actions';
import { DRAG_AND_DROP_CONSTANTS } from 'utils/dndBoard/constants';

const PageDropdown = ({ dispatch, columnId, pageId, thumbnails, setConfirmDeleteCard }) => {
	const [toggleDropdown, setToggleDropdown] = useState(false);
	const showRemoveType = useMemo(() => columnId !== DRAG_AND_DROP_CONSTANTS.UNORDERED_TYPE, [columnId]);

	const removeType = () => {
		const { [columnId]: columnToUpdate, ...restColumns } = thumbnails.columns;

		const newOrder = {
			...thumbnails,
			columns: {
				...restColumns,
				not_detected: {
					...thumbnails.columns[DRAG_AND_DROP_CONSTANTS.UNORDERED_TYPE],
					pageIds: [...thumbnails.columns[DRAG_AND_DROP_CONSTANTS.UNORDERED_TYPE].pageIds, pageId],
				},
			},
		};

		if (thumbnails.columns[columnId].pageIds.length <= 1) {
			newOrder.columnOrder = thumbnails.columnOrder.filter((id) => id !== columnId);
		} else {
			newOrder.columns[columnId] = { ...columnToUpdate, pageIds: columnToUpdate.pageIds.filter((id) => id !== pageId) };
		}

		dispatch(reorderThumbnails(newOrder));
	};

	return (
		<Dropdown
			className='pointer ml-n3 page-dropdown nav-link-icon'
			open={toggleDropdown}
			toggle={(e) => {
				e.stopPropagation();
				setToggleDropdown((isVisible) => !isVisible);
			}}
		>
			<DropdownToggle tag='i' className='fas fa-ellipsis-v p-1 mb-n1 text-warning' />
			<DropdownMenu small right className='p-0'>
				{showRemoveType && (
					<DropdownItem className='px-2 py-1' onClick={removeType}>
						<i className='fas fa-times mr-3 text-danger' />
						<strong>Typ entfernen</strong>
					</DropdownItem>
				)}
				<DropdownItem className='px-2 py-1' onClick={() => setConfirmDeleteCard(true)}>
					<i className='far fa-trash-alt mr-3 text-danger' />
					<strong>Seite löschen</strong>
				</DropdownItem>
			</DropdownMenu>
		</Dropdown>
	);
};

// Take thumbnails from redux state
const mapStateToProps = ({ savedDocument: { thumbnails } }) => ({ thumbnails });

export default connect(mapStateToProps)(memo(PageDropdown));
